var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingDetail)?_c('div',{staticClass:"eu-pa_6 eu-align_center"},[_c('emd-loader',{attrs:{"type":"_invert"}})],1):_c('invite-detail-content',{attrs:{"invite":_vm.invite},on:{"getInvite":_vm.getInvite}})
}
var staticRenderFns = []

export { render, staticRenderFns }